import { render, staticRenderFns } from "./RdeCommonContents.vue?vue&type=template&id=21e4b777"
import script from "./RdeCommonContents.vue?vue&type=script&lang=js"
export * from "./RdeCommonContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports